import packageJson from "../../package.json"

// 纯React版本：移除Electron依赖
const isTestServer = false;

console.log("isTestServer", isTestServer)

const testUrl = 'https://resource.mindplus.top/mindplus-test'

// 资源服务器
export const ASSET_SERVER = isTestServer ? testUrl : 'https://resource.mindplus.top/mindplus'

// 路由名称
let router_ = window.location.pathname.split("/")[1];
export const ROUTER_NAME = `/${router_||""}`; // 如: /home/

// 纯React版本：移除Electron路径相关功能
export const getAppdataPath = () => {
    return '/mindplus';
}

// 当前版本信息
export const CURRENT_VERSION = packageJson.version;